/* Norvena cloned-product kit — sticky offer bar, CTA wiring, static-section repair.
   The clone is served without the competitor's theme JS, so anything that was
   JS-driven (tabs, carousels, reveals) renders dead unless re-wired here. */
(function(){
  var OFFER = '#nz-offer';

  function offerEl(){
    return document.querySelector(OFFER)
        || document.querySelector('.lumin-product-block-qty-break')
        || document.querySelector('[class*="quantity-break"]')
        || document.querySelector('product-form, .product-form');
  }
  function toOffer(e){
    if(e){ e.preventDefault(); }
    var t = offerEl(); if(!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({top:y, behavior:'smooth'});
  }

  function wireCtas(){
    // every cloned link/button inside the clone goes to the offer, never off-site
    document.querySelectorAll('.nz a, .nz button').forEach(function(el){
      if(el.closest('#nz-sticky')) return;
      // carousel arrows, tab buttons, accordions and play buttons are CONTROLS, not CTAs —
      // wiring them to scroll-to-offer hijacked their own click handlers (the nz-06 arrows
      // jumped the page to the offer instead of advancing the track).
      if(el.matches('.nav-button, [data-tab], [class*="carousel"], [class*="arrow"], [class*="prev"], [class*="next"], [class*="play"], .store-faq-question, summary') ||
         el.closest('.nav-button, [data-tab], .store-faq-question')) return;
      if(el.tagName === 'A'){
        var h = el.getAttribute('href') || '';
        // leave real in-page anchors (FAQ accordions etc.) alone
        if(h && h.charAt(0) === '#' && h !== '#' && h !== '#nz-offer') return;
        el.setAttribute('href', OFFER);
      }
      el.addEventListener('click', toOffer);
    });
  }

  function sticky(){
    var bar = document.getElementById('nz-sticky'); if(!bar) return;
    bar.querySelector('button').addEventListener('click', toOffer);
    var target = offerEl();
    function upd(){
      // show once past the hero, hide again while the offer itself is on screen
      var past = window.pageYOffset > 520, over = false;
      if(target){ var r = target.getBoundingClientRect();
        over = r.top < window.innerHeight * 0.9 && r.bottom > 0; }
      bar.classList.toggle('nz-show', past && !over);
    }
    window.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd); upd();
  }

  // Sections that relied on competitor JS: reveal-on-scroll classes left content invisible.
  function reveals(){
    document.querySelectorAll('.nz .fade-out,.nz [class*="reveal"],.nz [class*="fade-in"]')
      .forEach(function(el){ el.classList.add('is-visible','in-view','revealed');
        if(getComputedStyle(el).opacity === '0') el.style.opacity = '1'; });
  }

  // Tabs (content_tabs). Contract in the cloned markup:
  //   button [data-tab] -> the PANEL'S id; both buttons and panels toggle an `active` token
  //   and the cloned CSS shows .tab-content-*.active / hides the rest.
  // My first version looked for [data-panel], which does not exist here, so clicking a tab
  // highlighted the button but never swapped the copy underneath.
  function tabs(){
    document.querySelectorAll('.nz [data-tab]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var id = btn.getAttribute('data-tab');
        var target = id && document.getElementById(id);
        if(!target) return;
        var group = btn.closest('[class*="content-tabs"]') || btn.closest('section') || document;
        group.querySelectorAll('[data-tab]').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        Array.prototype.forEach.call(target.parentElement.children, function(p){
          p.classList.remove('active');
        });
        target.classList.add('active');
      });
    });
  }


  // Carousel arrows + FAQ toggles, via DELEGATION on document.
  // Per-element listeners attached at init were lost on sections that Shopify re-renders
  // after load (nz-12's arrows resolved correctly but never fired). Delegation also covers
  // lazily revealed content.
  function delegated(){
    document.addEventListener('click', function(ev){
      var btn = ev.target.closest && ev.target.closest('.nz .nav-button');
      if(btn){
        ev.preventDefault();
        var sec = btn.closest('section') || btn.closest('[class*="shopify-section"]');
        var track = sec && sec.querySelector('.videos-grid, .testimonials-track, [class*="carousel-track"]');
        if(track && track.scrollWidth > track.clientWidth){
          var card = track.querySelector('.video-card, .testimonial-card, [class*="slide"]');
          var step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth * 0.8;
          var dir = /prev/.test(btn.className) ? -1 : 1;
          track.scrollLeft = track.scrollLeft + dir * step * 2;
        }
        return;
      }
      // nz-08 advisor cards: the + expands that advisor's testimonial
      var tog = ev.target.closest && ev.target.closest('.nz .testimonial-toggle');
      if(tog){
        var card = tog.closest('.advisor-card');
        if(card){
          var open = !card.classList.contains('nz-open');
          card.classList.toggle('nz-open', open);
          // set the panel inline: the cloned CSS pins max-height/opacity on this element and
          // the cascade kept winning, so drive it directly rather than via a class rule.
          var panel = card.querySelector('.advisor-testimonial');
          if(panel){
            // transition:none is ESSENTIAL — this panel carries a 0.8s transition, and
            // transition declarations outrank !important in the cascade, so the in-flight
            // value (0) kept overriding every inline/important style we set.
            // Write the whole declaration block at once with !important. Individual
            // style.setProperty calls and class-based rules both lost to the cloned CSS
            // that pins this panel shut; replacing cssText is the only thing that holds.
            panel.style.cssText = open
              ? 'transition:none!important;max-height:900px!important;opacity:1!important;visibility:visible!important;overflow:visible!important;height:auto!important;'
              : 'transition:none!important;max-height:0!important;opacity:0!important;visibility:hidden!important;overflow:hidden!important;height:0!important;';
          }
          var wrap = card.querySelector('.advisor-image-wrapper');
          if(wrap) wrap.setAttribute('aria-expanded', open);
        }
        return;
      }
      // nz-06 UGC cards: click the play overlay to start that video (and pause the rest)
      var play = ev.target.closest && ev.target.closest('.nz .nz-play');
      if(play){
        var wrap = play.closest('.video-wrapper');
        var vid  = wrap && wrap.querySelector('video');
        if(vid){
          document.querySelectorAll('.nz .video-wrapper video').forEach(function(o){
            if(o!==vid){ o.pause(); o.muted = true;
              var w=o.closest('.video-wrapper'); if(w) w.classList.remove('nz-playing'); }
          });
          vid.muted = false; vid.play();
          wrap.classList.add('nz-playing');
        }
        return;
      }
      var q = ev.target.closest && ev.target.closest('.nz .store-faq-question');
      if(q){
        var item = q.closest('.store-faq-item');
        if(item) item.classList.toggle('nz-open');
      }
    }, false);
  }


  function init(){ wireCtas(); sticky(); reveals(); tabs(); delegated(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
